import "./files.css";
import { cx } from "./tokens.ts";

export type ProgressProps = {
  /** 0…1; absent = indeterminate. */
  value?: number;
  /** Fill: accent.text, status.warning (nearly full) or status.danger (full, failed). */
  tone?: "accent" | "warning" | "danger";
  /** Accessible name ("Uploading photo.png"). */
  accessibilityLabel?: string;
  testID?: string;
};

/** A thin linear progress bar. Native: `ProgressView(value:)` (linear) / Material 3 `LinearProgressIndicator`. */
export function Progress({ value, tone = "accent", accessibilityLabel, testID }: ProgressProps) {
  const pct = value === undefined ? undefined : Math.round(Math.min(1, Math.max(0, value)) * 100);
  return (
    <div
      className={cx("b-progress", tone !== "accent" && `b-progress-${tone}`, pct === undefined && "b-progress-indeterminate")}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={pct}
      aria-label={accessibilityLabel}
      data-testid={testID}
    >
      <div className="b-progress-bar" style={{ width: `${pct ?? 30}%` }} />
    </div>
  );
}
